import { useQuery } from 'common/hooks';
import { getAllObjectivesApi } from '../objectives.service';
import { ObjectiveResponse } from '../types/objective.type';

export const useGetAllObjectives = () => {
  const queryResponse = useQuery(['my-objectives'], getAllObjectivesApi, {
    select: (response) => ({
      ...response,
      data: response.data.objectives as ObjectiveResponse[],
    }),
  });

  return {
    ...queryResponse,
    data: queryResponse?.data?.data,
  };
};
